import { cn } from '@/lib/cn'
import { useSlaTimer, slaToneTextClass } from '../../hooks/useSlaTimer'
import { isTerminalStatus } from '../../types'
import type { AlertStatus, SlaInfo } from '../../types'

/**
 * Single-line, fixed-width SLA cell. Updates once per minute via useSlaTimer.
 * Terminal alerts (any closed_* + merged) show a static "—".
 */
export function SlaCell({ sla, status }: { sla: SlaInfo; status: AlertStatus }) {
  const active = !isTerminalStatus(status)
  const { label, tone } = useSlaTimer({
    startedAt: sla.started_at,
    deadlineAt: sla.deadline_at,
    active,
  })
  return (
    <span
      className={cn(
        'block whitespace-nowrap font-mono tabular-nums text-xs',
        slaToneTextClass(tone),
      )}
      aria-label={`SLA: ${label}`}
    >
      {label}
    </span>
  )
}
